import { IconProps } from '.'

export function GearIcon({
  width = 18,
  height = 18,
  color = 'currentColor',
  ...props
}: IconProps): JSX.Element {
  return (
    <svg
      viewBox='0 0 20 20'
      focusable='false'
      width={width}
      height={height}
      fill={color}
      aria-hidden
      role='img'
      {...props}
    >
      <path
        fill='currentColor'
        d='M16.2502 9.99935C16.2502 9.80768 16.2419 9.62435 16.2252 9.43268L17.7752 8.25768C18.1085 8.00768 18.2002 7.54102 17.9919 7.17435L16.4335 4.48268C16.2252 4.11602 15.7752 3.96602 15.3919 4.13268L13.6002 4.89102C13.2919 4.67435 12.9669 4.48268 12.6252 4.32435L12.3835 2.39935C12.3335 1.98268 11.9752 1.66602 11.5585 1.66602H8.45021C8.02521 1.66602 7.66688 1.98268 7.61688 2.39935L7.37521 4.32435C7.03354 4.48268 6.70854 4.67435 6.40021 4.89102L4.60854 4.13268C4.22521 3.96602 3.77521 4.11602 3.56688 4.48268L2.00854 7.18268C1.80021 7.54935 1.89188 8.00768 2.22521 8.26602L3.77521 9.44102C3.75854 9.62435 3.75021 9.80768 3.75021 9.99935C3.75021 10.191 3.75854 10.3743 3.77521 10.566L2.22521 11.741C1.89188 11.991 1.80021 12.4577 2.00854 12.8243L3.56688 15.516C3.77521 15.8827 4.22521 16.0327 4.60854 15.866L6.40021 15.1077C6.70854 15.3243 7.03354 15.516 7.37521 15.6743L7.61688 17.5994C7.66688 18.016 8.02521 18.3327 8.44188 18.3327H11.5502C11.9669 18.3327 12.3252 18.016 12.3752 17.5994L12.6169 15.6743C12.9585 15.516 13.2835 15.3243 13.5919 15.1077L15.3835 15.866C15.7669 16.0327 16.2169 15.8827 16.4252 15.516L17.9835 12.8243C18.1919 12.4577 18.1002 11.9993 17.7669 11.741L16.2169 10.566C16.2419 10.3743 16.2502 10.191 16.2502 9.99935ZM10.0335 12.916C8.42521 12.916 7.11688 11.6077 7.11688 9.99935C7.11688 8.39102 8.42521 7.08268 10.0335 7.08268C11.6419 7.08268 12.9502 8.39102 12.9502 9.99935C12.9502 11.6077 11.6419 12.916 10.0335 12.916Z'
      />
    </svg>
  )
}
